module.exports = __webpack_public_path__ + "img/logo-transparent.19e97e62.png";